import { DisplayTextOverflowDynamic } from "components/DisplayFields/DisplayTextOverflowDynamic";

interface AuditLogRowProps {
  keyToUse: string;
  entityName?: string;
  stateLabel?: string;
}

export const AuditLogRow = ({ keyToUse, entityName, stateLabel }: AuditLogRowProps) => (
  <tr key={keyToUse} className="no-hover">
    <td className="entityName">
      <DisplayTextOverflowDynamic value={entityName} />
    </td>
    <td className="state">{stateLabel}</td>
  </tr>
);
